import { render, staticRenderFns } from "./specialist_detail.vue?vue&type=template&id=72bdf496&"
import script from "./specialist_detail.vue?vue&type=script&lang=js&"
export * from "./specialist_detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports